<template>
    <div class="logistic-pop">
        <div class="logisticTitle">物流状态</div>
        <template v-if="!(order.orderStatus == 7 || order.orderSubStatus == 506)">
            <p class="logisticHint">您的订单商品已打包完成，已安排配送到自提点团点</p>
            <p class="logisticTime" v-if="order.estimatedDeliveryTime"><van-icon name="clock-o" color="#BD7055" size="16px"/><span class="estimated">预计到达时间 </span><span>{{order.estimatedDeliveryTime}}</span></p>
        </template>
        <div class="logisticItem" v-if="order.orderStatus == 7">
            <div class="left">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_hx.png">
                <div class="line"></div>
            </div>
            <div class="right">
                <h3 class="red">用户已核销</h3>
                <p>{{order.delevery[0].completeTime}}</p>
            </div>
        </div>
        <div class="logisticItem" v-if="order.orderStatus == 7 || order.orderSubStatus == 506">
            <div class="left">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_zd2.png" v-if="order.orderSubStatus == 506">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_zd1.png" v-else>
                <div class="line"></div>
            </div>
            <div class="right">
                <h3 :class="{red:order.orderSubStatus == 506}">已送达团点</h3>
                <p>{{order.delevery[0].deliverFinishTime}}</p>
                <div class="phone" @click.stop="openPhone">
                    <van-icon name="phone" />
                    <span>联系团点</span>
                </div>
            </div>
        </div>
        <div class="logisticItem" v-if="order.orderStatus >= 5 || order.orderSubStatus == 506">
            <div class="left">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_sh2.png" v-if="order.orderStatus == 5">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_sh1.png" v-else>
                <div class="line"></div>
            </div>
            <div class="right">
                <h3 :class="{red:order.orderStatus == 5 && order.orderSubStatus != 506}">配送中</h3>
                <p>{{order.sellerShipTime}}</p>
            </div>
        </div>
        <div class="logisticItem" v-if="order.orderStatus >= 4 || order.orderSubStatus == 506">
            <div class="left">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_zf2.png" v-if="order.orderStatus == 4">
                <img src="https://i3.ulecdn.com/i/order/logistic/wl_icon_zf1.png" v-else>
                <div class="line"></div>
            </div>
            <div class="right">
                <h3>支付成功</h3>
                <p>{{order.buyerPayTime}}</p>
            </div>
        </div>
		<van-popup v-model="isShowPhone" class="phoneCon" round closeable @closed="closePhonePop" @click-overlay="closePhonePop">
            <div class="phoneTitle">联系方式</div>
            <div class="phoneDiv">
                <div class="phoneItem">
                    <span>团长</span>
                    <span class="phoneNum">{{phone.userMobile}}</span>
                    <div class="iconBtn" @click="telPhone(phone.userMobile)" >
                        <van-icon name="phone"/>
                        <span>联系</span>
                    </div>
                </div>
                <div class="phoneItem">
                    <span>团点</span>
                    <span class="phoneNum">{{phone.sitePhone}}</span>
                    <div class="iconBtn" @click="telPhone(phone.sitePhone)" >
                        <van-icon name="phone"/>
                        <span>联系</span>
                    </div>
                </div>
            </div>
		</van-popup>        
    </div>	
</template>
<script>
import {getSiteContact} from "@/libs/api";
export default {
  name: "shareTip",
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isShowPhone: false,
      phone: {}
    };
  },
  methods: {
    closePhonePop() {
        this.isShowPhone = false;
    },
    openPhone(){
        getSiteContact({ siteId: this.order.siteId, clientCallType: "H5" },"jsoncallback").then((res) => {
            if (res.returnCode == '0000') {
                this.phone = res.data;
                this.isShowPhone = true;
            } else {
                this.$toast(res.returnMessage || '自提点电话获取失败，请稍后再试')
            }
        });        
    },
    telPhone(phone){
        location.href = 'tel://' + phone;
    }
  },
  created() {},
  mounted() {
    console.log(this.order);
  }
};
</script>
<style lang="scss" scoped>
.logistic-pop{
	padding: 15px;
	.logisticTitle{
		color: #323233;
		font-size: 16px;
		font-weight: 700;
		text-align: center;
		padding: 0 0 10px 0;
	}
	.logisticHint{
		color: #8c8c8c;
		font-size: 13px;
		padding: 10px 0;		
	}
	.logisticTime{
		font-size: 13px;
		border-radius: 13px;
		background: linear-gradient( 270deg, #FCF9F4 0%, #F8EFE5 100%);
		padding: 5px 8px;
		margin-bottom: 20px;
		>span{
			color: #BD7055;
			&.estimated{
				color: #5A5A5A;
				margin-left: 5px;
			}
		}
	}
	.logisticItem{
		position: relative;
		display: flex;
		justify-content: space-between;
		.left{
			width: 40px;
			img{
				width: 22px;
				height: 22px;
				display: block;
			}
			.line{
				position: relative;
				// top: 10px;
				left: 10px;
				width: 1px;
				height: 36px;
				background: #E5E5E5;
			}
		}
		.right{
			width: calc(100% - 40px);
			position: relative;
			h3{
				font-size: 15px;
				font-weight: 700;
				color: #1e1e1e;
				margin-bottom: 10px;
				&.red{
					color: #FF2727;
				}
			}
			p{
				font-size: 13px;
				color: #8c8c8c;
			}
			.phone{
				position: absolute;
				top: 5px;
				right: 0;
				border-radius: 14px;
				border: 1px solid #BEBEBE;
				padding: 4px 7px;
			}
		}
	}
    .phoneCon{
        width: 80%;
        padding: 10px;
        .phoneTitle{
            color: #323233;
            font-size: 16px;
            font-weight: 700;
        }
        .phoneDiv{
            padding: 20px 0 0 0;
            .phoneItem{
                // background: red;
                background: #F8F9FB;
                border-radius: 11px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 48px;
                margin-bottom: 10px;
                padding: 10px;
                >span{ 
                    font-size: 14px;
                    color: #5A5A5A;
                }
                .phoneNum{
                    color: #1E1E1E;
                    font-size: 16px;
                    font-weight: 700;
                }
                .iconBtn{
                    font-size: 12px;
                    color: #FF2727;
                    background: #FFE9E9;
                    border-radius: 12px;
                    padding: 5px 8px;
                    span{
                        margin-left: 5px;
                    }
                }
            }
        }
    }
}
</style>
